module.exports = __webpack_public_path__ + "static/img/feature7.3cf9466.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feature7.png
// module id = r/7G
// module chunks = 0